import { render, staticRenderFns } from "./DebugInstanceBadge.vue?vue&type=template&id=26284be6&scoped=true&"
import script from "./DebugInstanceBadge.vue?vue&type=script&lang=js&"
export * from "./DebugInstanceBadge.vue?vue&type=script&lang=js&"
import style0 from "./DebugInstanceBadge.vue?vue&type=style&index=0&id=26284be6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26284be6",
  null
  
)

export default component.exports